module.exports = __webpack_public_path__ + "img/wczhf.9b36d68f.png";